/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FilteredQuery } from '../../models/filtered-query';
import { GetUserNotificationsQueryResult } from '../../models/get-user-notifications-query-result';
import { SortedQuery } from '../../models/sorted-query';

export interface ApiNotificationCenterGetNotificationsGet$Plain$Params {
  token?: string;
  UnRead?: boolean;
  PageNumber?: number;
  PageSize?: number;
  Filters?: Array<FilteredQuery>;
  Sorts?: Array<SortedQuery>;
  SearchTerm?: string;
}

export function apiNotificationCenterGetNotificationsGet$Plain(http: HttpClient, rootUrl: string, params?: ApiNotificationCenterGetNotificationsGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetUserNotificationsQueryResult>> {
  const rb = new RequestBuilder(rootUrl, apiNotificationCenterGetNotificationsGet$Plain.PATH, 'get');
  if (params) {
    rb.query('token', params.token, {});
    rb.query('UnRead', params.UnRead, {});
    rb.query('PageNumber', params.PageNumber, {});
    rb.query('PageSize', params.PageSize, {});
    rb.query('Filters', params.Filters, {});
    rb.query('Sorts', params.Sorts, {});
    rb.query('SearchTerm', params.SearchTerm, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetUserNotificationsQueryResult>;
    })
  );
}

apiNotificationCenterGetNotificationsGet$Plain.PATH = '/api/NotificationCenter/GetNotifications';
